import { useQuery } from '@tanstack/react-query';
import type { SearchMedicationsParams } from '@lotushealth/lotushealth_js_sdk/schemas';

import { fetchSearchMedications } from '../api/searchMedications.js';
import { rxKeys } from './keys.js';

export function searchMedicationsQueryDefinition(params: SearchMedicationsParams) {
  return {
    queryKey: rxKeys.medicationsSearch(params),
    queryFn: ({ signal }: { signal?: AbortSignal }) => fetchSearchMedications(params, signal),
  } as const;
}

export function useSearchMedicationsQuery(params: SearchMedicationsParams | undefined) {
  const enabled = Boolean(params && params.name.trim() !== '');
  return useQuery({
    queryKey: params
      ? rxKeys.medicationsSearch(params)
      : (['rx', 'medications', 'search', ''] as const),
    queryFn: ({ signal }: { signal?: AbortSignal }) => {
      if (!params) {
        throw new Error('Missing medication search params');
      }
      return fetchSearchMedications(params, signal);
    },
    enabled,
  });
}
